// extracted by mini-css-extract-plugin
module.exports = {"card":"create_card__3DlfQ"};